import { observer } from 'mobx-react';
import React from 'react';
import { formatImagePath } from '~/utils/formatter';
import { Icons } from '~/assets/fonts/Icons/icons';
import { localeStore } from '~/mobx/localesStore';

interface INoDataProps {
  message: string;
}

const NoData: React.FC<INoDataProps> = observer(({ message }: INoDataProps): JSX.Element => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center mt-6">
      <img src={formatImagePath(`${Icons.BranchesTree}.svg`)} alt={message} className="image__no-found mb-6" />
      <p className="family-medium text-size-24 color-gray2">{localeStore.t(message)}</p>
    </div>
  );
});

export default NoData;
